import React, { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import {
  getByFilterAuditLogs
} from "../../../actions/audit_logs_actions";
import TableAuditLogs from "./TableAuditLogs";
import "../../../sass/adminPanel/_admin.scss";
import debounce from 'lodash/debounce';

export const AuditLogsList = () => {
  const dispatch = useDispatch();

  const list = useSelector(
    (state) => state.auditLogs.list
  );
  const filterFactory = useSelector((state) => state.factories.filterFactory); 

  
  const countLogs = useSelector(
    (state) => state.auditLogs.countLogs
  );
  
  const search = useSelector((state) =>  state.pageInfo.search);
  const page = useSelector((state) => state.auditLogs.currentPage);
  const rowsPerPage = useSelector((state) => state.auditLogs.rowsPerPage);


  useEffect(() => {
  const debouncedDispatch = debounce(() => {
    dispatch(getByFilterAuditLogs(rowsPerPage, page * rowsPerPage, -1, filterFactory, search));
  }, 300); // 300ms debounce

  debouncedDispatch();

  return () => {
    debouncedDispatch.cancel(); // Cancel any pending call on cleanup
  };
}, [dispatch, page, rowsPerPage, filterFactory, search]);

  return ( 
    <div  className = "admin_page">     
      <TableAuditLogs list={list} countLogs={countLogs}> </TableAuditLogs>
    </div>
  );
};
